import React, { useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Link from "@material-ui/core/Link";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import { toast } from "react-toastify";
import api from "../../services/api";

const useStyles = makeStyles(theme => ({
    root: {
        width: "100vw",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: theme.palette.background.default,
    },
    paper: {
        backgroundColor: theme.palette.type === "light" ? "rgba(255, 255, 255, 0.85)" : "rgba(30, 30, 30, 0.85)",
        backdropFilter: "blur(20px)",
        borderRadius: "24px",
        padding: theme.spacing(4, 6),
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        boxShadow: "0 8px 32px 0 rgba(31, 38, 135, 0.37)",
        border: "1px solid rgba(255, 255, 255, 0.18)",
        maxWidth: "450px",
        width: "100%",
    },
    form: {
        width: "100%", // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
        borderRadius: "12px",
        height: "48px",
        fontWeight: "bold",
    },
    logo: {
        margin: "0 auto",
        width: "80%",
        marginBottom: theme.spacing(4),
    }
}));

const ForgetPassword = () => {
    const classes = useStyles();
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await api.post("/auth/forget-password", { email });
            toast.success("Si el correo existe, se ha enviado un enlace de recuperación.");
        } catch (err) {
            toast.error("Ocurrió un error al procesar tu solicitud.");
        }
        setLoading(false);
    };

    return (
        <Container component="main" maxWidth="xs" className={classes.root}>
            <CssBaseline />
            <div className={classes.paper}>
                <Typography component="h1" variant="h5" style={{ fontWeight: "bold", marginBottom: "20px" }}>
                    Recuperar Contraseña
                </Typography>
                <Typography variant="body2" color="textSecondary" align="center" style={{ marginBottom: "20px" }}>
                    Ingresa tu correo electrónico y te enviaremos un enlace para restablecer tu contraseña.
                </Typography>
                <form className={classes.form} onSubmit={handleSubmit}>
                    <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        id="email"
                        label="Correo Electrónico"
                        name="email"
                        autoComplete="email"
                        autoFocus
                        value={email}
                        onChange={e => setEmail(e.target.value)}
                    />
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        color="primary"
                        className={classes.submit}
                        disabled={loading}
                    >
                        {loading ? "Enviando..." : "Enviar Enlace"}
                    </Button>
                    <div style={{ textAlign: "center", marginTop: "10px" }}>
                        <Link component={RouterLink} to="/login" variant="body2">
                            Volver al inicio de sesión
                        </Link>
                    </div>
                </form>
            </div>
        </Container>
    );
};

export default ForgetPassword;
